import { render, staticRenderFns } from "./content-sections.page.vue?vue&type=template&id=7b1bed1e&scoped=true&"
import script from "./content-sections.page.vue?vue&type=script&lang=js&"
export * from "./content-sections.page.vue?vue&type=script&lang=js&"
import style0 from "./content-sections.page.vue?vue&type=style&index=0&id=7b1bed1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1bed1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
